<template>
  <div id="tags-view-container" class="tags-view-container" :style="{width: scrollWidth + 'px'}">
    <ScrollPane ref="scrollPane" class="tags-view-wrapper" @scroll="handleScroll">
      <div class="scroll-context">
        <div
            v-for="tag in visitedViews"
            ref="tag"
            :key="tag.path"
            :class="isActive(tag)?'active':''"
            class="tags-view-item"
            @contextmenu.prevent.native="openMenu(tag,$event)"
            @click="goNext(tag)"
        >
          {{ tag.title }}
          <span v-if="!isAffix(tag)" class="el-icon-close" @click.prevent.stop="closeSelectedTag(tag)" ><ElIcons name="close"/></span>
        </div>
      </div>
    </ScrollPane>
    <ul v-show="visible" :style="{left:left+'px',top:top+'px'}" class="contextmenu">
      <li v-if="!isAffix(selectedTag)" @click="closeSelectedTag(selectedTag)">Close</li>
      <li @click="closeOthersTags">Close Others</li>
      <li @click="closeAllTags(selectedTag)">Close All</li>
    </ul>
  </div>
</template>

<script>
import ScrollPane from "@/layout/components/TagsView/ScrollPane";
import path from "path";
export default {
name: "index",
  components: { ScrollPane },
  data() {
    return {
      visible: false,
      top: 0,
      left: 0,
      selectedTag: {},
      affixTags: [],
      scrollWidth: '',
    }
  },
  computed: {
    visitedViews() {
      return this.$store.state.visitedViews
    },
  },
  watch: {
    $route() {
      this.addTags()
      this.moveToCurrentTag()
    },
    visible(value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu)
      } else {
        document.body.removeEventListener('click', this.closeMenu)
      }
    }
  },
  mounted() {
  console.log(this.visitedViews)
    this.getScrollWidth()
    window.onresize = () => {
      return (()=>{
        this.getScrollWidth()
      })();
    }
    this.addTags()
  },
  methods: {
    goNext(tag) {
      this.$router.push({
        path: tag.path,
        query: {
          menuId: tag.query.menuId
        }
      })
    },
    getScrollWidth() {
      const offsetLeft = this.$el.getBoundingClientRect().left // container margin left
      // console.log(this.$el)
      const offsetWidth = document.body.offsetWidth
      this.scrollWidth = offsetWidth - offsetLeft - 180
    },
    isActive(route) {
      return route.path === this.$route.path
    },
    isAffix(tag) {
      return tag.meta && tag.meta.affix
    },
    addTags() {
      const { name } = this.$route
      if (name && name != 'Lock') {
        this.$store.dispatch('addView', this.$route)
      }
      return false
    },
    moveToCurrentTag() {
      const tags = this.$refs.tag
      this.$nextTick(() => {
        for (const tag of tags) {
          if (tag.to === this.$route.path) {
            this.$refs.scrollPane.moveToTarget(tag)
            break
          }
        }
      })
    },
    closeSelectedTag(view) {
      this.$store.dispatch('delView', view).then(({ visitedViews }) => {
        if (this.isActive(view)) {
          this.toLastView(visitedViews, view)
        }
      })
    },
    closeOthersTags() {
      this.$router.push(this.selectedTag)
      this.$store.dispatch('delOthersViews', this.selectedTag).then(() => {
        this.moveToCurrentTag()
      })
    },
    closeAllTags(view) {
      this.$store.dispatch('delAllViews').then(({ visitedViews }) => {
        if (this.affixTags.some(tag => tag.path === view.path)) {
          return
        }
        this.toLastView(visitedViews, view)
      })
    },
    toLastView(visitedViews, view) {
      const latestView = visitedViews.slice(-1)[0]
      if (latestView) {
        this.$router.push(latestView.fullPath)
      } else {
        this.$router.push('/home')
      }
    },
    openMenu(tag, e) {
      const offsetLeft = this.$el.getBoundingClientRect().left // container margin left
      console.log(this.$el)
      this.left = e.clientX - offsetLeft + 15 // 15: margin right
      this.top = e.clientY
      this.visible = true
      this.selectedTag = tag
    },
    closeMenu() {
      this.visible = false
    },
    handleScroll() {
      this.closeMenu()
    }
  }
}
</script>


<style lang="scss" scoped>
.tags-view-container {
  //width: 100%;
  line-height: 48px;
  position: relative;
  //margin-left: 24px;
  //background: #fff;
  //border-bottom: 1px solid #d8dce5;
  //box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .12), 0 0 3px 0 rgba(0, 0, 0, .04);
  .tags-view-wrapper {
    .scroll-context {
      height: 48px;
      display: flex;
      align-items: center;
      .tags-view-item {
        display: flex;
        align-items: center;
        position: relative;
        cursor: pointer;
        height: 26px;
        line-height: 26px;
        //border: 1px solid #ededed;
        border-radius: 4px;
        color: #495060;
        background: #f6f6f6;
        padding: 2px 12px;
        font-size: 12px;
        margin-right: 8px;
        //margin-top: 4px;
        //&:first-of-type {
        //  margin-left: 15px;
        //}
        //&:last-of-type {
        //  margin-right: 15px;
        //}
        &.active {
          background-color: #42b983;
          color: #fff;
          border-color: #42b983;
          //&::before {
          //  content: '';
          //  background: #fff;
          //  display: inline-block;
          //  width: 8px;
          //  height: 8px;
          //  border-radius: 50%;
          //  position: relative;
          //  margin-right: 6px;
          //}
        }
      }
    }

  }
  .contextmenu {
    width: 110px;
    margin: 0;
    background: #fff;
    z-index: 3000;
    position: absolute;
    list-style-type: none;
    padding: 5px 0;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 400;
    color: #333;
    box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, .3);
    li {
      margin: 0;
      padding: 7px 16px;
      cursor: pointer;
      line-height: 16px;
      &:hover {
        background: #eee;
      }
    }
  }
}
</style>

<style lang="scss">
//reset element css of el-icon-close
.tags-view-wrapper {
  .tags-view-item {
    .el-icon-close {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 16px;
      height: 16px;
      vertical-align: middle;
      border-radius: 50%;
      text-align: center;
      transition: all .3s cubic-bezier(.645, .045, .355, 1);
      transform-origin: 100% 50%;
      margin-left: 4px;
      margin-right: -4px;
      &:before {
        transform: scale(.6);
        display: inline-block;
        //vertical-align: -3px;
      }
      &:hover {
        background-color: rgba(0,0,0,0.1);
        color: #fff;
      }
    }
  }
}
</style>
